import {useMemo} from 'react'
import {makeSelectResidentsByUnit} from '../../Utils/residentUtils'
import {useSelector} from 'react-redux'

/**
 * @param {string} unitId
 * @param {boolean?} includePast
 */
function useGetResidentsByUnit(unitId, includePast = false) {
  const selectorByUnit = useMemo(() => makeSelectResidentsByUnit(unitId, includePast), [unitId, includePast])
  return useSelector(selectorByUnit)
}

export default useGetResidentsByUnit
